<template>
  <div class="pagination">
    <span>第 <a>{{currentPage}}</a> 页</span>
    <span @click="goFirstPage" class="page">首页</span>
    <span @click="goPrePage" class="page">上一页</span>
    <span @click="goNextPage" class="page">下一页</span>
    <span @click="goLastPage" class="page">尾页</span>
    <span>共 <a>{{pageCount}}</a> 页</span>
  </div>
</template>
<script>
export default {
  props:[
    "currentPage",
    "pageCount"
  ],
  methods:{
    goFirstPage() {
      this.$emit("goPrePage",1)
    },
    goLastPage() {
      this.$emit("goNextPage",this.pageCount)
    },
    goPrePage() {
      var page = this.currentPage==1?1:this.currentPage-1
      this.$emit("goPrePage",page)
    },
    goNextPage() {
      var page = this.currentPage==this.pageCount?this.currentPage:this.currentPage+1
      this.$emit("goNextPage",page)
    }
  }
}
</script>
<style scoped>
.pagination {
  text-align: center;
  padding: 0;
}
  .pagination span {
    padding: 0 10px;
    color: #003c73;
  }
  span a {
    color: #e63636;
    text-decoration: underline;
  }
  .page {
  }
  .page:hover {
    color: #e63636;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/pagination.vue